import { createFileRoute } from '@tanstack/react-router';

import { TodayScreen } from '../features/today/TodayScreen';

/** `/` = «اليوم» (§1.2 و§6.1). ملف المسار رقيق: التركيب كله في الميزة. */
export const Route = createFileRoute('/')({ component: TodayScreen });
